import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { FormControlProps } from '@mui/material/FormControl/FormControl';
import { SelectProps } from '@mui/material/Select/Select';
import { v4 as uuidV4 } from 'uuid';

import { getLinkedInputLabelAndSelectProps } from '~/components/GenericForm/EnumSelect/data';
import { Enum } from '~/data/enums';

type PropsType = SelectProps & {
  FormControlProps?: FormControlProps;
  enumOptions?: Enum[];
  includeEmptyOption?: boolean;
  helperText?: string;
};
export const EnumSelect = (props: PropsType) => {
  const {
    FormControlProps,
    enumOptions,
    includeEmptyOption,
    helperText,
    children,
    ...selectProps
  } = props;

  const { label, required, id } = selectProps;
  const linkedComponentProps = getLinkedInputLabelAndSelectProps({
    label,
    selectId: id || uuidV4(),
    required,
  });

  const resolvedSelectProps = {
    ...selectProps,
    ...linkedComponentProps.selectProps,
  };

  return (
    <FormControl {...FormControlProps}>
      <InputLabel {...linkedComponentProps.inputLabelProps} />
      <Select {...resolvedSelectProps}>
        {children}
        {!required && !!includeEmptyOption && (
          <MenuItem value={''} key={'empty'}>
            -
          </MenuItem>
        )}
        {!!enumOptions &&
          enumOptions.map((option) => (
            <MenuItem value={option.code} key={option.code}>
              {option.name}
            </MenuItem>
          ))}
      </Select>
      {helperText && (
        <FormHelperText error={resolvedSelectProps.error}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
